import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { IFilter } from '../../interfaces/ifilter';
import { IFilterDataResponse, IFilterEvent } from '../../interfaces/ifilter-event';

import { FilterService, IFilterSubject } from '../../services/filter.service';
import { filter } from 'rxjs';
import { IFilterModel } from '../../models/filter-model';




export interface IDataFilterDropdown {
  name: string;
  checked?: boolean;
  id: string | number;
}

export interface IFilterData {
  id: number;
  name: string;   
}




@Component({
  selector: 'split-filter-dropdown',
  templateUrl: './split-filter-dropdown.component.html',
  styleUrls: ['./split-filter-dropdown.component.scss'],
})
export class SplitFilterDropdownComponent implements OnChanges, OnInit {


  @Input() data!: any[];

  @Input() field!: string;

  @Input() label!: string;

  @Input() key!: string;

  @Input() id!: string;

  @Input() groupId!: string;

  @Input() required: boolean = false;

  protected _data: any[] = [];

  protected get countDataChecked() {
    return this.data.map(item => item.checked).reduce((a, b) => a + b, 0);
  }
  

  protected get dataChecked() {
    return this.data.filter(item => item.checked);
  }

  protected filterModel!: IFilterModel;


  @Output() onFilterEvent: EventEmitter<IFilterModel> = new EventEmitter<IFilterModel>();
  @Output() onSearchEvent: EventEmitter<IFilter[]> = new EventEmitter<IFilter[]>();

  @ViewChild('op') public overlayPanel!: OverlayPanel;
  isActiveOverlay: boolean = false;



  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.filterService.filters = this.filterModel;

    this.filterService.filterSubject.pipe(
      filter((event: IFilterSubject) => event.action === "CLEAR"),
      filter((event: IFilterSubject) => event.id === this.groupId),
      filter((event: IFilterSubject) =>  this.required == false)
    ).subscribe((event: IFilterSubject) => {
      this.data.filter(item => item.readonly == false).forEach(item => item.checked = false);
      this._data = this.copy();
      this.onEmit();
    });

    this.filterService.filterSubject.pipe(
      filter((event: IFilterSubject) => event.action === "DELETE"),
      filter((event: IFilterSubject) => event.id === this.groupId),
      filter((event: IFilterSubject) => event.data?.key === this.key),
      filter((event: IFilterSubject) => this.required == false)
    ).subscribe(() => {
      this.data.filter(item => item.readonly == false).forEach(item => item.checked = false);
      this._data = this.copy();
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["data"]) {
      this._data = this.copy();
      this.data = this._data;
      console.log(this.key);
    }  

    if(changes["key"]) {
      this.filterModel = {
        id: this.groupId,
        type: "FILTER",
        key: this.key,
        data: this._data,
        component: this,
        filter: []
      }
    }
  }

  copy() {
    return this.data.map((item) => ({...item, checked: item.checked ?? false, readonly: item.readonly ?? false, key: this.key}));
  }

  showOverlayPanel(event: any) {
    this.overlayPanel.show(event);
    this.isActiveOverlay = true;
  }

  hideOverlayPanel() {
    this._data = this.copy();
    this.isActiveOverlay = false;
  }

  onChange(event: any, position: number) {
    this._data[position].checked = event.checked;
  }

  onSearch(event: any) {
    console.log(event);
    const value = event.toLowerCase().trim();

    if (value.length === 0) {
      this._data = [...this.data];
      return;
    }

    this._data = this.data.filter(item =>
      item.name.toLowerCase().includes(value)
    );
    console.log(this._data);

    /*let filter: IFilter = {
      property: "search",
      fields: [this.field],
      value: event,
      key: this.key + "Search"
    }
    this.onSearchEvent.emit([filter]);*/
  }

  onEmit() { 
    let dataChecked = this._data.filter(item => item.checked);
    let filter: IFilter[] = dataChecked.map(item => ({
      property: this.field,
      fields: [],
      value: item.id,
      key: this.key,
    })); 

    

    let filterModel: IFilterModel = {
      ...this.filterModel,
      data: this._data,
      filter: filter
    }

    //this.filterService.set(this.id, this.field, this.key, "FILTER", dataChecked as IFilterData[])

    this.data = this._data;
    this.filterService.send(filterModel);
    this.onFilterEvent.emit(filterModel);
    this.overlayPanel.hide();
  }
}
